const checkDate = date =>
  date === '01/01/1900' || date === '1/1/1900' || date === '12/31/1899' || date === '1900-01-01' ? '' : date;

export default checkDate;
